import React, { useState, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container } from './styles';

export default function CadenciaNew() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/cadencia', {
        name: data.name,
      });

      toast.success('Cadencia criada com sucesso');
      history.push('/cadencia');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o cadencia, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastrar Cadência</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input icon="MdRepeat" label="Nome" name="name" type="text" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
